import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const JanuarySehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={1} title="January Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default JanuarySehriIftaar;
